module.exports = __webpack_public_path__ + "static/media/gh_styles3.784b74fd.jpg";